export default __webpack_public_path__ + "static/media/portfolio-simple-2-p2.45ef0d73.jpg";